import { Box, Typography, Stack } from "@mui/material";
import type { TemplateTestResultItem } from "../types/api-types";
import TestResultCard from "./test-result-card";

interface TestResultsProps {
  results: TemplateTestResultItem[];
}

const TestResults = ({ results }: TestResultsProps) => {
  if (results.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        border: 1,
        borderColor: "grey.300",
        borderRadius: 2,
        p: 2,
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{ mb: 1.5, fontSize: "0.875rem" }}
      >
        Results ({results.length})
      </Typography>
      <Box
        sx={{
          maxHeight: 485,
          overflowY: "auto",
          pr: 0.5,
          "&::-webkit-scrollbar": {
            width: 6,
          },
          "&::-webkit-scrollbar-track": {
            bgcolor: "grey.100",
            borderRadius: 3,
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "grey.400",
            borderRadius: 3,
            "&:hover": {
              bgcolor: "grey.500",
            },
          },
        }}
      >
        <Stack spacing={1}>
          {results.map((result: TemplateTestResultItem, index: number) => (
            <TestResultCard
              key={result.id || index}
              result={result}
              index={index}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default TestResults;
